export function getPercentage(equipment, value){
    if (!equipment.infos) return;
    if (!equipment.infos.thresholds) return;
    if (!equipment.infos.thresholds.warning || !equipment.infos.thresholds.danger) return;

    let currentValue;
    if(value) currentValue = value;
    else currentValue = equipment.lastMessage.value;

    let min = 4;
    let max = 20;

    return (currentValue - min) / (max - min).toFixed();
}

export function getPercentageFB(value){
    let min = 4;
    let max = 20;
    return ((value - min) / (max - min).toFixed()) * 100;
}

export function getState(equipment, percentage){
    if (!equipment.infos) return;
    if (!equipment.infos.thresholds) return;
    if (!equipment.infos.thresholds.warning || !equipment.infos.thresholds.danger) return;
    if(!percentage) percentage = getPercentage(equipment) * 100;

    let danger = equipment.infos.thresholds.danger.value;
    let warning = equipment.infos.thresholds.warning.value;

    let state;
    if (percentage < danger) state = "danger";
    else if (percentage < warning) state = "warning";
    else state = "success";

    return state;
}
